module.exports = __webpack_public_path__ + "img/heart.2beea9d4.svg";